export function setUndefinedIfEmpty(value) {
    if (value === '')
        return undefined;
    return value;
}
//# sourceMappingURL=form.js.map